export enum RoleGroup {
	Nurse = "Nurse",
	Aide = "Aide",
}

export enum HiringShiftType {
	Day = "day",
	Night = "night",
}

export enum ShiftFilter {
	All = "all",
	Day = "day",
	Night = "night",
}

export const ROLE_GROUPS = Object.values(RoleGroup);

export const ROLE_GROUP_MATCHES: Record<RoleGroup, string[]> = {
	[RoleGroup.Nurse]: ["RN", "LPN", "LVN"],
	[RoleGroup.Aide]: ["CNA", "CMA", "NAS", "RNA"],
};

export const ROLE_HPPD_ALLOCATION: Record<RoleGroup, number> = {
	[RoleGroup.Nurse]: 0.2,
	[RoleGroup.Aide]: 0.8,
};

export const UNDERUTILIZED_ALLOCATION: Record<RoleGroup, Record<HiringShiftType, number>> = {
	[RoleGroup.Nurse]: { [HiringShiftType.Day]: 1, [HiringShiftType.Night]: 1 },
	[RoleGroup.Aide]: { [HiringShiftType.Day]: 3, [HiringShiftType.Night]: 1 },
};

/** Shared theme colors for the Hiring Module */
export const COLORS = {
	primary: "#7B77AA",
	success: "#4CAF50",
	warning: "#FF9500",
	error: "#FE6C5F",
	textSecondary: "#9CA3B8",
	textMuted: "#B8C0D9",
	border: "#E1E6EF",
	background: "#F4F7FE",
} as const;

export const ROLE_COLORS: Record<string, string> = {
	[RoleGroup.Nurse]: COLORS.primary,
	[RoleGroup.Aide]: COLORS.success,
};

export const SHIFTS_PER_WEEK = 3;
export const SHIFTS_PER_NURSE_2WEEKS = SHIFTS_PER_WEEK * 2;

export const SHIFT_FILTER_LABELS: Record<ShiftFilter, string> = {
	[ShiftFilter.All]: "All Shifts",
	[ShiftFilter.Day]: "Day Only",
	[ShiftFilter.Night]: "Night Only",
};

export interface RoleRecommendation {
	role: string;
	day: number;
	night: number;
	total: number;
}

export const matchesRoleGroup = (nurseRole: string, roleGroup: string): boolean => {
	const matches = ROLE_GROUP_MATCHES[roleGroup as RoleGroup];
	if (!matches) return false;
	return matches.some((r) => nurseRole.includes(r));
};

export const isDayShift = (shiftType?: string): boolean => {
	const t = shiftType?.toLowerCase();
	return t === HiringShiftType.Day || t === "morning";
};
